var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.696,
    height: 20,
    viewBox: "0 0 18.696 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #00095b;\n      }\n\n      .cls-1 {\n        clip-rule: evenodd;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-1",
    d: "M1489.5,715.845h-3.739v1.25h4.985v-5H1489.5Zm-3.738-18.75v1.25h3.739V702.1h1.246v-5Zm-12.465,15h-1.246v5h4.986v-1.25h-3.74Zm0-13.75h3.74V697.1h-4.986v5h1.246Z",
    transform: "translate(-1472.052 -697.095)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    className: "cls-2",
    width: 135.651,
    height: 96.956
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(-1472.052 -697.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    className: "cls-3",
    transform: "translate(1472.052 697.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(-78.043 -0.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    className: "cls-2",
    width: 19.565,
    height: 20.869,
    transform: "translate(77.608)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.bd7b52b487cf19d756adeb79821a4cb2.svg";
export { ForwardRef as ReactComponent };